import { render, staticRenderFns } from "./EBike.vue?vue&type=template&id=99244d4e"
import script from "./EBike.vue?vue&type=script&lang=js"
export * from "./EBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports